import React from 'react';
import moment from 'moment';
import { CustomerNote } from '../../../models/CustomerNote';
import { Card, Header, CreatedAt, CreatedBy, Body } from './styles';

interface ICardCustomerNoteProps {
    note?: CustomerNote;
}

const CardCustomerNote: React.FC<ICardCustomerNoteProps> = ({
    note
}) => {

    return (
        <Card>
            <Header>
                <CreatedAt>
                    {moment(note?.createdAt).format('DD/MM/yyyy HH:mm:ss')}
                </CreatedAt>
                <CreatedBy>
                    {note?.createdBy?.name}
                </CreatedBy>
            </Header>
            <Body>
                {note?.value}
            </Body>
        </Card>
    );
}

export {CardCustomerNote};